module.exports = __webpack_public_path__ + "static/media/cash-app.ed4fdc50.png";